import React, { useState } from "react"
import { LocationProvider } from "@reach/router"
import { headerConfigDefault } from "../components/header/Header"
import { footerConfigDefault } from "../components/Footer"

const GlobalContext = React.createContext()

const GlobalProvider = ({ children }) => {
  const [themeDark, setThemeDark] = useState(false)
  const [visibleOffCanvas, setVisibleOffCanvas] = useState(false)

  const toggleTheme = () => {
    setThemeDark(!themeDark)
  }

  const toggleOffCanvas = () => {
    setVisibleOffCanvas(!visibleOffCanvas)
  }

  const [headerConfig, setHeaderConfig] = useState(headerConfigDefault)
  const [footerConfig, setFooterConfig] = useState(footerConfigDefault)

  return (
    <LocationProvider>
      <GlobalContext.Provider
        value={{
          themeDark,
          toggleTheme,
          visibleOffCanvas,
          toggleOffCanvas,
          headerConfig,
          setHeaderConfig,
          footerConfig,
          setFooterConfig,
        }}
      >
        {children}
      </GlobalContext.Provider>
    </LocationProvider>
  )
}

export default GlobalContext
export { GlobalProvider }
